export function formatNumber(value: number | string, locale = "de-DE") {
  if (!value) return "";
  const num = Number(value);
  if (isNaN(num)) return "";
  return new Intl.NumberFormat(locale).format(num);
}

export function parseNumber(formatted: string) {
  return Number(formatted.replace(/\./g, "").replace(/,/g, ""));
}
